import { createContext } from "../util/create-context.js";
export const [CollapsibleContextProvider, useCollapsibleContext] = createContext({
    name: "CollapsibleContext",
    errorMessage: "<Collapsible.Trigger> and <Collapsible.Content> must be used within a <Collapsible>",
});
//# sourceMappingURL=Collapsible.context.js.map